<template>
    <v-card>
        <v-card-title
            class="headline grey lighten-2"
            primary-title
        >Are you sure to delete the report of "{{ candidate.object }}"?</v-card-title>
        <v-card-text class="mt-5">
            Reported at {{ candidate.date }} like {{ candidate.report_type }}.
        </v-card-text>
         <v-divider></v-divider>
        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn small color="primary"  @click="closeDelete">Cancel</v-btn>
            <v-btn small color="error"  @click="onDelete">Delete</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: "DeleteReport",
    props: ["candidate", "show"],
    data() {
        return {
        };
    },
    methods: {
        closeDelete() {
            this.$emit('update:show', false);
        },
        onDelete() {
            this.$api.deleteReport(this.candidate.id).then(() => {
                this.$emit('update:candidate', {});
                this.closeDelete();
            }).catch(error => {
                alert(error);
            });
        }
    }
};
</script>